import type { Subscription } from "@/api";
import type { useFormatter } from "next-intl";

/** The day the current period ends, and whether the subscription stops on that day instead of renewing. */
export function getPeriodEnd(
  subscription: Subscription,
  format: ReturnType<typeof useFormatter>,
): { day: string; isEnding: boolean } | null {
  const date = subscription.endsAt ?? subscription.currentPeriodEnd;
  if (!date) return null;

  return {
    day: format.dateTime(new Date(date), { month: "short", day: "numeric" }),
    isEnding: subscription.endsAt !== null,
  };
}
